import { useDispatch } from "react-redux";
import { spoolBillToManager } from "../../redux/action/utilActions";
import { routeMobilePrint } from "../../native/automatic-print-routing.mjs";
import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import BillComponent from "./BillComponent";
import CashBookPrint from "./CashBookPrint";
import useDetectPrint from "../../hooks/useDetectPrint";
import { isMealBillAndroid, androidPrinter } from "../../native/mealbill-android.mjs";
import price from "../../helpers/calculatePrice";
import roundOffTotal from "../../helpers/roundOffTotal";
import moment from "moment";

import { createAndroidBillReceipt, prepareBillImage } from "../../native/android-bill.mjs";

const PrintComponent = ({
  headers,
  footers,
  printData,
  printType,
  restaurant,
  logo,
  gstNumber,
  fssaiNumber,
  branchAddress,
  containerStyle,
  receiptMessage,
  printSetting,
  isRestaurantAdmin,
  tableType,
}) => {
  const isPrinting = useDetectPrint();
  const dispatch = useDispatch();

  const componentRef = useRef();
  const lastPrintData = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      // alert("print completed");
    },
  });

  useEffect(() => {
    if (isRestaurantAdmin && !(isMealBillAndroid() && printType !== "cashbook")) {
      handlePrint();
      return;
    }

    if (isPrinting || !printData) return;

    // ── Android native thermal print path ──────────────────────────────────
    if (isMealBillAndroid() && printType !== "cashbook") {
      try {
        if (lastPrintData.current === printData) return; // Deduplicate Strict Mode double renders
        lastPrintData.current = printData;

        routeMobilePrint("bill", {
          spool: () => dispatch(spoolBillToManager(printData)),
          direct: async (profile) => {
            const capabilities = await androidPrinter.capabilities();
            if (!capabilities.receiptFormats?.includes("lines-v2")) {
              throw new Error("Update MealBill Android to print this bill layout");
            }
            const width = profile.width;
            const logoData = null; // Logo disabled on Android
            // One ID per triggered print event, reused throughout this attempt. No automatic retry.
            const jobId = `bill:${globalThis.crypto.randomUUID()}`;
            const receipt = createAndroidBillReceipt({
              printData, restaurant, branchAddress, gstNumber, fssaiNumber,
              receiptMessage, tableType, printSetting, logoData, width, jobId,
              price, roundOffTotal,
              formatDate: (value) => moment(value).format("DD/MM/YYYY HH:mm"),
            });

            return androidPrinter.print(receipt).then(
              (result) => console.log("Android bill print:", result.status, receipt.jobId),
              (error) => {
                console.error("Android bill print failed:", error.message, error.result);
                window.alert(`Print failed: ${error.message}`);
              }
            );
          },
        }).catch(error => {
          console.error("Android bill receipt build error:", error.message);
          window.alert(`Print error: ${error.message}`);
        });
      } catch (error) {
        console.error("Android bill receipt build error:", error.message);
        window.alert(`Print error: ${error.message}`);
      }
      return; // Never fall back to browser print after native attempt
    }

    // ── Electron desktop path ───────────────────────────────────────────────
    if (window?.api?.isElectron) {
      console.log("isElectron inside", window.api);
      window.api.send(printData);
    } else {
      // ── Browser fallback (print dialog) ──────────────────────────────────
      handlePrint();
    }
  }, [printData, isPrinting]);

  const renderComponent = () => {
    console.log(
      "cash book",
      printData,
      restaurant,
      logo,
      gstNumber,
      receiptMessage,
      branchAddress,
      printSetting,
    );
    if (printType === "cashbook") {
      return (
        <CashBookPrint
          ref={componentRef}
          printData={printData}
          restaurant={restaurant}
          logo={logo}
          gstNumber={gstNumber}
          fssaiNumber={fssaiNumber}
          receiptMessage={receiptMessage}
          branchAddress={branchAddress}
          printSetting={printSetting}
        />
      );
    }
    return (
      <BillComponent
        ref={componentRef}
        orderData={printData}
        restaurant={restaurant}
        logo={logo}
        gstNumber={gstNumber}
        fssaiNumber={fssaiNumber}
        receiptMessage={receiptMessage}
        branchAddress={branchAddress}
        printSetting={printSetting}
        tableType={tableType}
      />
    );
  };
  return (
    <div style={{ ...containerStyle, width: "100%" }}>
      <div style={{ display: "none" }}>{renderComponent()}</div>
    </div>
  );
};
export default PrintComponent;
